import * as patch from './patch.ts';
import * as patchCommit from './patchCommit.ts';
import * as patchRemove from './patchRemove.ts';

export { patch, patchCommit, patchRemove };
